import { render, staticRenderFns } from "./HomePic.vue?vue&type=template&id=4f865dfc&scoped=true&"
import script from "./HomePic.vue?vue&type=script&lang=js&"
export * from "./HomePic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f865dfc",
  null
  
)

export default component.exports